<script lang="ts">
    import { tooltip } from "../../../helper"
    import { mdiCurrencyEur } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import { _ } from "svelte-i18n"

    export let statusSummary: OperationStatusSummary
    export let positions: OperationPosition[]
    export let position: OperationPosition

    const reason = {
        CAD: $_("components.table.fields.chargeableField.CAD"),
        NTF: $_("components.table.fields.chargeableField.NTF"),
        BTF: $_("components.table.fields.chargeableField.BTF"),
        GNE: $_("components.table.fields.chargeableField.GNE"),
        CPY: $_("components.table.fields.chargeableField.CPY"),
        SBE: $_("components.table.fields.chargeableField.SBE"),
        BNI: $_("components.table.fields.chargeableField.BNI"),
        BNA: $_("components.table.fields.chargeableField.BNA"),
        SW: $_("components.table.fields.chargeableField.SW"),
        SBO: $_("components.table.fields.chargeableField.SBO"),
        SBA: $_("components.table.fields.chargeableField.SBA"),
        SBR: $_("components.table.fields.chargeableField.SBR"),
        SHO: $_("components.table.fields.chargeableField.SHO"),
        WVU: $_("components.table.fields.chargeableField.WVU"),
        QNR: $_("components.table.fields.chargeableField.QNR"),
    }

    let reasons: string[] = []
    positions.forEach((position) => {
        if (!position.chargeable && !reasons.includes(position.chargeableReason)) {
            reasons.push(position.chargeableReason)
        }
    })
    let reasonsText = "\n\n"
    reasons.map((r) => {
        // @ts-ignore
        reasonsText += (reason[r] || "") + "\n"
    })
</script>

{#if position && position.chargeable !== undefined}
    <div class="states">
        <span
            class="state {position.chargeable ? 'green' : 'gray'}"
            use:tooltip="{{
                content: `${
                    position.chargeable
                        ? $_('components.table.fields.chargeableField.chargeable')
                        : $_('components.table.fields.chargeableField.notChargeable') +
                          $_('components.table.fields.chargeableField.reason', {
                              values: {
                                  // @ts-ignore
                                  reason: reason[position.chargeableReason] || '',
                              },
                          })
                }`,
            }}"
        >
            <span class="left"></span><span class="right"></span><span class="icon">
                <Icon path="{mdiCurrencyEur}" />
            </span>
        </span>
    </div>
{:else if statusSummary && statusSummary.chargeable !== undefined}
    <div class="states">
        <span
            class="state {{ 0: 'grey', 60: 'split', 100: 'green' }[statusSummary.chargeable]}"
            use:tooltip="{{
                content: {
                    0: $_('components.table.fields.chargeableField.notChargeable', {
                        values: {
                            reasonsText: reasonsText,
                        },
                    }),
                    60: $_('components.table.fields.chargeableField.partiallyChargeable', {
                        values: {
                            chargeableCount: statusSummary.chargeableCount,
                            totalCount: positions.length,
                            reasonsText: reasonsText,
                        },
                    }),
                    100: $_('components.table.fields.chargeableField.fullyChargeable'),
                }[statusSummary.chargeable],
            }}"
        >
            <span class="left"></span><span class="right"></span><span class="icon">
                <Icon path="{mdiCurrencyEur}" />
            </span>
        </span>
    </div>
{/if}
